<template>
    <v-media
        @click.native="onClick"
        class="text-md"
        :class="compCssClasses"
        :halfFilling="false"
        xAlign="c"
        yAlign="c"
    >
        <template v-slot:left>
            <svg
                class="tab-icon checked"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
            >
                <path
                
                    d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
                />

                 <path
                    
                    d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200z"
                />
            </svg>

            <svg
                class="tab-icon unchecked"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
            >
                <path
                   
                    d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200z"
                />
            </svg>

        </template>

        <template v-slot:right>
            <slot>{{label}}</slot>
        </template>
    </v-media>
</template>

<script>
import { mapMutations } from "vuex";
import { propsStringEnumValidator } from "@/libs/utils";
import VMedia from "@/components/ui/VMedia";

const validatorType = propsStringEnumValidator(["l", "r"]);

export default {
    name: "TabButton",
    components: { VMedia },
    props: {
        label: {
            type: String
        },
        isActive: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            required: true,
            validator: validatorType
        },
        form: {
            type: String,
            required: true
        }
    },
    computed: {
        compCssClasses: function() {
            const arr = [`tab`];
            if (this.type) arr.push(`tab-${this.type}`);
            if (this.isActive) arr.push(`active`);
            return arr;
        }
    },

    methods: {
        ...mapMutations("forms", {
            setActiveFrom: "SET_ACTIVE_FORM"
        }),

        onClick: function() {
            this.setActiveFrom({ form: this.form });
        }
    }
};
</script>

<style scoped lang="scss">
.tab {
    width: 280px;
    text-align: center;
    padding: 15px 0;
    background: #f6f6f6;
    color: rgba(0, 0, 0, 0.7);

    justify-content: center;
    align-items: center;

    border: 1px solid #ccc;
    cursor: pointer;
    margin: 15px 0;

    &-l {
        border-radius: 4px 0 0 4px;
    }
    &-r {
        border-radius: 0 4px 4px 0;
    }

    & > span {
        border-bottom: 1px dashed rgba(223, 134, 134, 0.4);
    }

    &-icon{
        width: 15px;
        height: 15px;
        padding: 10px;
        
    }
}

.checked{ display: none; }
.unchecked{
    fill:rgba(0, 0, 0, 0.4);
}


.active {
    background: #fdda24;
    font-weight: 500;
    color: #000000;
    & > span {
        border-bottom: none;
    }


    & .checked{
        display: block;
    }

    & .unchecked{
        display: none;
    }
}
</style>

<style lang="scss">
@media (max-width: 768px) {
}

@media (max-width: 411px) {
}

@media (max-width: 375px) {
    .tab {
        width: 50%;
    }
}
</style>
